import { Typography, Spacer } from "@fullscript/aviary-web";

import * as styles from "./CustomDisclaimer.styles";

type Alignment = "center" | "start" | "end";

interface Props {
  disclaimer?: string | null;
  alignment?: Alignment;
  spacer?: boolean;
}

const CustomDisclaimer = ({ disclaimer, spacer = true, alignment = "start" }: Props) => {
  if (!disclaimer) return null;

  return (
    <>
      {!!spacer && <Spacer size="large" />}
      <div css={styles.container(alignment)}>
        <div css={styles.content}>
          <Typography variant="footnote" intention="neutral" colorIntensity="subtle">
            {disclaimer}
          </Typography>
        </div>
      </div>
    </>
  );
};

export { CustomDisclaimer };
